define([
    'deepmerge',
    '../../../config/global',
], (
    merge,
    global
) => {
    return () => {
        const config = merge.all([
            global,
            window.envConfig,
        ]);

        Object.keys(config).forEach(key =>
            angular.module('portal.config').constant(key, config[key]));
    };
});


// WEBPACK FOOTER //
// ./app/js/portal/constants.js